<template>
    <div class="m-2">
        <header v-if="linkedTags" class="d-flex align-items-center bg-tags text-white round mb-1">
            <font-awesome-icon class="m-2" icon="tag" size="lg" />
            <span class="m-0 text-white flex-fill">
                <strong>{{ $t("settings.tags.Tags") }}</strong>
            </span>
        </header>

        <b-alert v-if="linkedTags.length === 0" :show="linkedTags.length === 0" variant="primary">
            <div class="alert-body">
                <font-awesome-icon class="mr-50" icon="triangle-exclamation" size="lg" />
                <span>{{ $t("entities.tags.No linked tags") }}</span>
            </div>
        </b-alert>

        <b-form-group class="full-height">
            <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-1">
                <li v-for="tag in linkedTags" :key="tag.id" class="list-inline-item">
                    <b-form-tag
                        :style="styleByColor(tag.color)"
                        :title="tag.name"
                        class="mr-50 tag-margin"
                        variant="primary"
                        @remove="unlinkTag(tag)"
                    />
                </li>
            </ul>

            <b-dropdown block menu-class="w-100" variant="primary">
                <template v-slot:button-content> <b-icon icon="tag-fill" />{{ $t("tags-select-add") }} </template>
                <b-dropdown-item v-for="tag in selectableTags" :key="tag.id" @click="linkTag(tag)">
                    {{ tag.name }}
                </b-dropdown-item>
                <b-dropdown-text v-if="selectableTags.length === 0">
                    {{ $t("tags-not-available") }}
                </b-dropdown-text>
            </b-dropdown>
        </b-form-group>
    </div>
</template>

<script>
import { BAlert, BFormTags, BIcon, BFormGroup, BFormTag, BDropdown, BDropdownItem, BDropdownText } from "bootstrap-vue";
import { computed, defineComponent, toRefs } from "@vue/composition-api";
import useTags from "@/composables/v2.1/useTags";
import { textColorByBackgroundColor, styleByColor } from "@/utils/color";
import useActiveChat from "@/composables/useActiveChat";

export default defineComponent({
    components: {
        BAlert,
        BFormTags,
        BFormGroup,
        BFormTag,
        BDropdown,
        BDropdownItem,
        BDropdownText,
        BIcon,
    },
    props: {
        linkedTags: {
            type: Array,
            required: false,
        },
    },

    setup(props, { emit }) {
        const { tags } = useTags();

        const linkTag = (tag) => emit("update-linked-tags", [...props.linkedTags, tag]);

        const unlinkTag = (tag) => {
            const linkedTags = [...props.linkedTags];
            const indexToRemove = linkedTags.findIndex((linkedTag) => linkedTag.id === tag.id);

            linkedTags.splice(indexToRemove, 1);

            emit("update-linked-tags", linkedTags);
        };

        const selectableTags = computed(() => {
            const linkedTagIds = props.linkedTags.map((linkedTag) => linkedTag.id);
            return tags.value.filter((tag) => !linkedTagIds.includes(tag.id));
        });

        return {
            tags,
            textColorByBackgroundColor,
            styleByColor,
            linkTag,
            unlinkTag,
            selectableTags,
        };
    },
});
</script>

<style lang="scss" scoped>
.tag-margin {
    margin-bottom: 2px;
}
</style>
